import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('composer')

export const FETCH_SAVED_REPLIES = makeConstant('FETCH_SAVED_REPLIES')
export const FETCH_SAVED_REPLIES_PENDING = makeConstant('FETCH_SAVED_REPLIES_PENDING')
export const FETCH_SAVED_REPLIES_SUCCESS = makeConstant('FETCH_SAVED_REPLIES_SUCCESS')
export const FETCH_SAVED_REPLIES_FAILURE = makeConstant('FETCH_SAVED_REPLIES_FAILURE')

export const UPDATE_SAVED_REPLY = makeConstant('UPDATE_SAVED_REPLY')
export const UPDATE_SAVED_REPLY_PENDING = makeConstant('UPDATE_SAVED_REPLY_PENDING')
export const UPDATE_SAVED_REPLY_SUCCESS = makeConstant('UPDATE_SAVED_REPLY_SUCCESS')
export const UPDATE_SAVED_REPLY_FAILURE = makeConstant('UPDATE_SAVED_REPLY_FAILURE')

export const SELECT_SAVED_REPLY = makeConstant('SELECT_SAVED_REPLY')
export const CLEAR_SELECTED_SAVED_REPLY = makeConstant('CLEAR_SELECTED_SAVED_REPLY')

export const SET_COMPOSER_TEXT_TO_INSERT = makeConstant('SET_COMPOSER_TEXT_TO_INSERT')
export const CLEAR_COMPOSER_TEXT_TO_INSERT = makeConstant('CLEAR_COMPOSER_TEXT_TO_INSERT')




// WEBPACK FOOTER //
// ./src/scripts/app/modules/composer/constants.js